import React, { useEffect, useState } from 'react'
import styles from '../../../styles'
import { makeStyles } from '@material-ui/core/styles'
import thousandsSeparator from '../../../utils/thousandsSeparator'
import { FormattedMessage, useIntl } from 'react-intl'
import classNames from 'classnames'
import Button from '../../../components/button/Button'
import { useHistory, useLocation } from 'react-router'
import ContractDetails from './ContractDetails'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import links from '../../../enums/linksEnum'
import { propertyType } from '../../../enums/contractsEnum'
import SvgApartment from '../../../icons/Apartment'
import SvgGarage from '../../../icons/Garage'
import SvgApartmentFull from '../../../icons/ApartmentFull'
import SvgGarageFull from '../../../icons/GarageFull'
import { ModelDoc, PostDocumentModel } from '../../contracts/contracts_body/docs/docs_model'
import fetchFactory from '../../../utils/fetchFactory'
import { configEnum } from '../../../enums/fetchFactoryEnum'
import { convertDocumentList } from '../../contracts/contracts_body/docs/documentMapper'
import contractsTabEnum from '../../../enums/contractsTabEnum'
import Link from '../../../components/link/Link'
import Icon from '../../../components/icon/Icon'
import { ButtonBase } from '@material-ui/core'
import iconsEnum from '../../../enums/iconsEnum'
import { RequestItemModel } from '../../requests/requestsModel'
import { connect } from 'react-redux'
import { RootState } from '../../reducers'
import LinkCard from './LinkCard'
import useTheme from '@material-ui/core/styles/useTheme'
import portals from '../../../enums/portalsEnum'
import { saveInteractions } from '../../gtm/utils/gtmCallback'
import linksEnum from '../../../enums/linksEnum'
import { getRequestCategory } from '../../requests/requestMapper'

const useStyle = makeStyles((theme) => {
	return {
		...styles(theme),
		cardStyle: {
			background: 'white',
			textAlign: 'left',
			marginBottom: '20px'
		},
		cardHeaderStyle: {
			'& div:first-child': {
				paddingRight: '10px'
			},
			'& h2': {
				margin: 0
			},
			'& img': {
				width: '56px',
				height: '56px'
			}
		},
		cardHeaderLargeScreenStyle: {
			padding: '30px 30px 25px 30px',
			borderBottom: process.env.REACT_APP_TARGET === portals.campus ? '1px solid ' + theme.palette.blue['10'] : undefined
		},
		cardHeaderSmallScreenStyle: {
			padding: '25px 30px 25px 25px',
			borderBottom: process.env.REACT_APP_TARGET === portals.campus ? '1px solid ' + theme.palette.blue['10'] : undefined
		},
		cardBalanceStyle: {
			borderTop: '1px solid ' + theme.palette.blue['10'],
			borderBottom: '1px solid ' + theme.palette.blue['10'],

			'& span:last-child': {
				color: theme.palette.accessibility.main
			}
		},
		cardBalanceLargeScreenStyle: {
			padding: '16px 30px',
			fontSize: '14px',
			fontWeight: 'bold'
		},
		cardBalanceSmallScreenStyle: {
			padding: '16px 25px'
		},
		cardRequestDocumentsStyle: {
			padding: '30px 30px 0',

			'& h2': {
				margin: '0 0 15px'
			},
			'& .deadline': {
				marginBottom: 12
			}
		},
		cardLinkDocumentsStyle: {
			justifyContent: 'space-between'
		},
		cardButtonLargeScreenStyle: {
			padding: '30px'
		},
		cardButtonSmallScreenStyle: {
			padding: '16px 25px 25px'
		},
		textRecentDocuments: {
			marginBottom: 17,
			display: 'flex',
			justifyContent: 'space-between',

			'& svg': {
				fill: theme.palette.accessibility.main
			}
		}

	}
})

interface Store {
	requests: RequestItemModel[],
}

interface AcceptingProps {
	contract: ContractsModel,
	isLargeScreen: boolean
}

type CardContractsProps = AcceptingProps & Store

const CardContracts: React.FC<CardContractsProps> = (
	props
) => {
	const {
		contract,
		isLargeScreen,
		requests
	} = props

	const classes = useStyle()
	const theme = useTheme()
	const intl = useIntl()

	const [requestsInProgress, setRequestsInProgress] = useState<RequestItemModel[]>([])
	const type: string = `dashboard.contracts.type.${contract.type}`
	const img = contract.type === propertyType.apartment ?
		(
			process.env.REACT_APP_TARGET === portals.campus ?
				<SvgApartmentFull
					color={theme.palette.purple.main}
					width={56}
					height={56}
				/>
				:
				<SvgApartment
					color={theme.palette.blue.main}
					width={56}
					height={56}
				/>
		) : (
			process.env.REACT_APP_TARGET === portals.campus ?
				<SvgGarageFull
					color={theme.palette.purple.main}
					width={56}
					height={56}
				/>
				:
				<SvgGarage
					color={theme.palette.blue.main}
					width={56}
					height={56}
				/>
		)

	const history = useHistory()
	const location = useLocation()
	const [docs, setDocs] = React.useState<ModelDoc[]>([])
	const currentYear = new Date().getFullYear()

	const cardHeaderClass = classNames(
		{
			[classes.cardHeaderLargeScreenStyle]: isLargeScreen,
			[classes.cardHeaderSmallScreenStyle]: !isLargeScreen
		},
		classes.cardHeaderStyle,
		classes.flex,
		classes.alignCenter,
		classes.flexBetween
	)
	const cardTypeClass = classNames(
		classes.colorBlue,
		classes.title4
	)
	const cardBalanceClass = classNames(
		{
			[classes.cardBalanceLargeScreenStyle]: isLargeScreen,
			[classes.cardBalanceSmallScreenStyle]: !isLargeScreen
		},
		classes.cardBalanceStyle,
		classes.flex,
		classes.flexBetween
	)
	const cardRequestDocumentsClass = classNames(
		classes.cardRequestDocumentsStyle
	)

	const cardRecentClass = classNames(
		classes.text6,
		'deadline'
	)
	const cardButtonClass = classNames(
		{
			[classes.cardButtonLargeScreenStyle]: isLargeScreen,
			[classes.cardButtonSmallScreenStyle]: !isLargeScreen
		}
	)

	const textRecentClass = classNames(
		classes.colorBlue,
		classes.text5,
		classes.textRecentDocuments
	)

	const seeDetails = (contractId: string) => {
		saveInteractions(
			{
				category: location.pathname === linksEnum.dashboard ? 'Tableau de bord' : '',
				action: location.pathname === linksEnum.dashboard ? 'Blocs de mise en avant' : '',
				label: `Votre compte::${contract.type === propertyType.apartment ? 'Appartement' : 'Parking'}`
			}
		)

		history.push(`${links.contract}${contractId}`)
	}

	//Fetch docs for selected contract for the last 3 years
	useEffect(() => {
		const dataDoc: PostDocumentModel = {
			no_bail: contract.lease,
			years: [currentYear, currentYear - 1, currentYear - 2]
		}
		fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/contrat/getDocuments`,
			{
				body: JSON.stringify(dataDoc),
				method: configEnum.post
			})
			.then(
				(data: any) => {
					if (!Array.isArray(data)) {
						setDocs(convertDocumentList(Object.values(data)))
					} else {
						setDocs(convertDocumentList(data))
					}
				}
			)
	}, [contract, currentYear])

	//Check if docs is empty
	const isDocsEmpty = (docs: Array<ModelDoc>) => {
		return docs.length <= 0
	}

	//Check if requestInProgress is empty
	const isRequestInProgressEmpty = (requests: Array<RequestItemModel>) => {
		return requests.length <= 0
	}

	//Go to contracts tab on documents tab
	const goToDocuments = (contractId: string) => {
		history.push(`${links.contract}${contractId}${links.tabContract}${contractsTabEnum.documentsTab}`)
	}

	//Go to detail of request
	const goToDetail = (requestId: string) => {
		history.push(`${links.requests}/${requestId}`)
	}

	//Go to request tab
	const goToRequests = () => {
		history.push(links.requests)
	}

	useEffect(() => {
		setRequestsInProgress(requests.filter((item: RequestItemModel) => !item.cloture && !item.annule && item.bail_id === contract.id))
	}, [requests, contract.id])

	return (
		<div className={classes.cardStyle}>
			<div className={cardHeaderClass}>
				<div>
					<h2 className={cardTypeClass}>
						<FormattedMessage
							id={type}
							defaultMessage="Appartement"
							description="Dashboard contract type text"
						/>
					</h2>

					<ContractDetails
						contract={contract}
						color="colorBlue"
					/>
				</div>

				<div>
					{img}
				</div>
			</div>


			{!(process.env.REACT_APP_TARGET === portals.campus) &&
				<div className={cardBalanceClass}>
				<span className={classes.colorBlue}>
					<FormattedMessage
						id="dashboard.contracts.balance"
						defaultMessage="Solde"
						description="Dashboard contract balance text"
					/>
				</span>
					<span>{thousandsSeparator(-(contract.balance), false)}€</span>
				</div>
			}

			{
				isLargeScreen &&
				<>
					{
						!isRequestInProgressEmpty(requestsInProgress) &&
						<div className={cardRequestDocumentsClass}>
							<div className={textRecentClass}>
								<FormattedMessage
									id="dashboard.contracts.onGoingRequests"
									defaultMessage="Vos demandes en cours"
									description="Dashboard contract onGoingRequests text"
								/>
								<ButtonBase onClick={() => goToRequests()}>
									<Icon icon={iconsEnum.Right} size={10} />
								</ButtonBase>
							</div>
							{
								requestsInProgress.slice(0, 3).map((item: RequestItemModel) => {
									const requestCategory = getRequestCategory(item.category, intl)
									return (
										<div key={item.id} className={cardRecentClass}>
											<Link
												color="colorBlue"
												textStyle="text6"
												onClick={() => goToDetail(item.id)}
												hasChevron={false}
												key={item.id}
											>
												{
													`${requestCategory.subCategory} ${item.modifiedOn.toLocaleDateString()}`
												}
											</Link>
										</div>
									)
								})
							}
						</div>
					}

					{
						!isDocsEmpty(docs) &&
						<div className={cardRequestDocumentsClass}>
							<div className={textRecentClass}>
								<FormattedMessage
									id="dashboard.contracts.recentsDocuments"
									defaultMessage="Vos documents récents"
									description="Dashboard contract recentsDocuments text"
								/>
								<ButtonBase onClick={() => goToDocuments(contract.id)}>
									<Icon icon={iconsEnum.Right} size={10} />
								</ButtonBase>
							</div>
							{
								docs.slice(0, 2).map((doc: ModelDoc, key) => (
									<LinkCard key={key} doc={doc} />
								))
							}
						</div>
					}
				</>
			}

			<div className={cardButtonClass}>
				<Button
					color="colorWhite"
					onClick={() => seeDetails(contract.id)}
					background="backgroundDynamic"
					textStyle="text2"
					size="mediumButton"
					type="button"
					disabled={false}
				>
					<FormattedMessage
						id="dashboard.contracts.details"
						defaultMessage="Voir le détail"
						description="Dashboard contract details text"
					/>
				</Button>
			</div>
		</div>
	)
}

const mapStateToProps = (state: RootState) => (
	{
		requests: state.requests
	}
)

export default connect(mapStateToProps)(CardContracts)